import { fetchRequest, normalizeBookingResponse } from "./api/api.js";
import { transformCostData } from "./data-to-ui-adapters/data-transform-functions.js";
import { updateSummary } from "./ui/checkout-summary.js";
import { setDropdown } from "./ui/dropdown.js";
import { setCostState, getClientData } from "./state.js";
import { toggleDropdownValidation } from "./ui/dropdown.js";

export default () => {
    window.NewCheckout = {
        fetchRequest,
        updateSummary,
        transformCostData,
        normalizeBookingResponse,
        setDropdown,
        setCostState,
        getClientData,
        toggleDropdownValidation
    }
}